import { useGetCustomer, useGetCustomerTribe } from "@/services/api";
import { isFwbEligibleCustomer } from "@/utils/customerUtils";

type UseCustomerTribeOptions = {
  enabled?: boolean;
};

/**
 * The customer's tribe (`GET /tribe/customer`). Only requested once the
 * customer is loaded and eligible for Friends with Benefits, so business
 * customers never trigger it.
 */
export const useCustomerTribe = ({
  enabled = true,
}: UseCustomerTribeOptions = {}) => {
  const { data: customer } = useGetCustomer(undefined, {
    query: { enabled },
  });

  return useGetCustomerTribe({
    query: { enabled: enabled && isFwbEligibleCustomer(customer) },
  });
};
